import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function updatePlantillaXslt (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getUpdatePlantillaImagen.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/personalizacion/updatePlantillaXslt',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updatePlantillaXslt }
